module.exports = __webpack_public_path__ + "static/media/campnew.148d885b.png";